module.exports = __webpack_public_path__ + "static/img/logo.d5b445c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1